 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"1bfc9850","3":"5e2a4920","4":"95b64a6e","5":"b5800c5c3b374bb8b5a97c3365ea669d946aebc8","6":"de71a805","7":"d640cadca4fccead1793ab69c37ab07054ec0b2f","8":"4b6b6acb6b69bfe65c18c4a6fff1e089feecbcf7","9":"c369609605d104a3d33c589a5b4078a180e1ff5d","10":"7f9a90214293d19937bec8003e3afa2ed530c2ee","11":"33e28d289606c88f6d220fb454322ff3f1c1739a","12":"c8a18677afe50be1c64ded9c89c30dc1c054d2de","13":"abf364fd2c37a740c6f32f0c28f53f724ff6651e","14":"31664189","15":"2556e8ad4a6ece70618a8481a0a40a51349cb2ed","16":"0c6e6bb5ab5713c15739b8c8f423bbb54b06358f","17":"39536fbe1b129759f3598b7b524a8db97c24e71d","20":"252f366e","22":"component---src-pages-404-js","23":"component---src-pages-blogs-js","24":"component---src-pages-careers-js","25":"component---src-pages-contact-js","26":"component---src-pages-cookies-policy-js","27":"component---src-pages-data-management-js","28":"component---src-pages-ebooks-js","29":"component---src-pages-employee-management-js","30":"component---src-pages-enterprise-search-js","31":"component---src-pages-flexible-collaboration-js","32":"component---src-pages-hire-python-developers-js","33":"component---src-pages-index-js","34":"component---src-pages-learn-with-wersel-js","35":"component---src-pages-our-story-js","36":"component---src-pages-people-ai-analytics-js","37":"component---src-pages-privacy-policy-js","38":"component---src-pages-products-counterfeitx-index-js","39":"component---src-pages-products-dashx-index-js","40":"component---src-pages-products-discoverx-index-js","41":"component---src-pages-products-glassx-index-js","42":"component---src-pages-products-prex-index-js","43":"component---src-pages-products-pricex-index-js","44":"component---src-pages-products-scoopx-index-js","45":"component---src-pages-solutions-animated-video-production-index-js","46":"component---src-pages-solutions-brand-protection-index-js","47":"component---src-pages-solutions-data-advisory-service-index-js","48":"component---src-pages-solutions-data-analytics-solutions-index-js","49":"component---src-pages-solutions-data-as-service-index-js","50":"component---src-pages-solutions-data-visualization-index-js","51":"component---src-pages-solutions-marketplace-monitoring-index-js","52":"component---src-pages-solutions-mobile-app-development-london-index-js","53":"component---src-pages-solutions-web-scraping-index-js","54":"component---src-pages-solutions-wersel-product-page-optimization-index-js","55":"component---src-pages-terms-js","56":"component---src-pages-videos-js","57":"component---src-pages-write-for-us-js","58":"component---src-templates-post-post-js","59":"d64684d8"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"2b9b9a7707e1f4f18d94","2":"ddd7e0df624a3b9d331b","3":"c8f0e5d98520704be7e7","4":"6227fd36c72166467711","5":"5f47504da5995950b7c3","6":"22eedabd5962e36ceda4","7":"93c47be1c1c0a15a79a5","8":"7931005685c6bedd0dbf","9":"3320f926e6b825a02962","10":"93a3d782235f5fd805c4","11":"e243a54f345192bc69e8","12":"322223d2234725498161","13":"0513909b187eab3fdcda","14":"b0e99f2c3dbb1418b572","15":"54fe9e45157ab60f6ea7","16":"99e1e8aa446829afb73e","17":"c2ddd592f0af27df1921","19":"cf93b7c7ee5f1ab52077","20":"3cfcdad73e91862414e5","22":"f18a482284a1f3e80f84","23":"d573ce4a293d58e9680a","24":"caa6e385bb121d9ea378","25":"63f2b2fb709ae880f702","26":"7ba4db3117960f8144d6","27":"da5ea250ee8200415b6e","28":"272823f3f59188002621","29":"92c96ac003e4ff649595","30":"3f1f567fa211f3d98e1c","31":"2532480e71007145ad4f","32":"4b16d8798d269de29b4d","33":"1c7e0614668c7be217eb","34":"8642fad1715f8656a588","35":"b4ac8833c5aa2695ee20","36":"317bcfec15e2a2a0efa5","37":"d495a2cacb8182bde4d0","38":"bc5abd956a037ab8d9b3","39":"412cae933041ba1542dd","40":"a61e53795c0c53e0a4c6","41":"9d1720956c324e57e8ef","42":"dacf924444c78064eb5f","43":"1df9d5cbe5e7cef39063","44":"aa9c3a7cdc31c6615715","45":"79d39cda91178882807d","46":"5a55923dda37cd9148b1","47":"27f7014320f4846b8e09","48":"ca23c9e7d62d88ca4ef8","49":"1cc899a35e1a8f389a3c","50":"e55a9ec3c3523d9fe265","51":"3e2e0d1e7644d9f3e50b","52":"2900d969530e1a4cc1a2","53":"1034381adb6333870f54","54":"66b28473be1374a0fb93","55":"3b8ee95a5e71408d9679","56":"9b181841c0c0b05d770a","57":"c964f75b4bcc565522de","58":"15cf200df2b8613c9cfd","59":"fd58968bb308aa60eb66","62":"1f3ca3ae374e727110ca","63":"a7a7a2975c9956df648b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"1bfc9850","3":"5e2a4920","4":"95b64a6e","5":"b5800c5c3b374bb8b5a97c3365ea669d946aebc8","6":"de71a805","7":"d640cadca4fccead1793ab69c37ab07054ec0b2f","8":"4b6b6acb6b69bfe65c18c4a6fff1e089feecbcf7","9":"c369609605d104a3d33c589a5b4078a180e1ff5d","10":"7f9a90214293d19937bec8003e3afa2ed530c2ee","11":"33e28d289606c88f6d220fb454322ff3f1c1739a","12":"c8a18677afe50be1c64ded9c89c30dc1c054d2de","13":"abf364fd2c37a740c6f32f0c28f53f724ff6651e","14":"31664189","15":"2556e8ad4a6ece70618a8481a0a40a51349cb2ed","16":"0c6e6bb5ab5713c15739b8c8f423bbb54b06358f","17":"39536fbe1b129759f3598b7b524a8db97c24e71d","20":"252f366e","22":"component---src-pages-404-js","23":"component---src-pages-blogs-js","24":"component---src-pages-careers-js","25":"component---src-pages-contact-js","26":"component---src-pages-cookies-policy-js","27":"component---src-pages-data-management-js","28":"component---src-pages-ebooks-js","29":"component---src-pages-employee-management-js","30":"component---src-pages-enterprise-search-js","31":"component---src-pages-flexible-collaboration-js","32":"component---src-pages-hire-python-developers-js","33":"component---src-pages-index-js","34":"component---src-pages-learn-with-wersel-js","35":"component---src-pages-our-story-js","36":"component---src-pages-people-ai-analytics-js","37":"component---src-pages-privacy-policy-js","38":"component---src-pages-products-counterfeitx-index-js","39":"component---src-pages-products-dashx-index-js","40":"component---src-pages-products-discoverx-index-js","41":"component---src-pages-products-glassx-index-js","42":"component---src-pages-products-prex-index-js","43":"component---src-pages-products-pricex-index-js","44":"component---src-pages-products-scoopx-index-js","45":"component---src-pages-solutions-animated-video-production-index-js","46":"component---src-pages-solutions-brand-protection-index-js","47":"component---src-pages-solutions-data-advisory-service-index-js","48":"component---src-pages-solutions-data-analytics-solutions-index-js","49":"component---src-pages-solutions-data-as-service-index-js","50":"component---src-pages-solutions-data-visualization-index-js","51":"component---src-pages-solutions-marketplace-monitoring-index-js","52":"component---src-pages-solutions-mobile-app-development-london-index-js","53":"component---src-pages-solutions-web-scraping-index-js","54":"component---src-pages-solutions-wersel-product-page-optimization-index-js","55":"component---src-pages-terms-js","56":"component---src-pages-videos-js","57":"component---src-pages-write-for-us-js","58":"component---src-templates-post-post-js","59":"d64684d8"}[chunkId]||chunkId) + "." + {"0":"92184d2187211cbf2b46","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
